import {useCallback, useMemo} from 'react';

import {observer} from 'mobx-react-lite';

import type {GetComponentProps} from '../../../../../../utils/utility-types';
import type {Props} from './types';

import {Clickable} from '../../../../../../uikit/Clickable';
import {ListItem} from '../../components/ListItem';
import {ScheduleItemModel} from './model';

export const ProgramScheduleListItem = observer<Props>(
  ({item, onClick, onMoreIconClick}) => {
    const model = useMemo(() => new ScheduleItemModel(item), [item]);

    const onClickCb = useCallback(() => {
      onClick(item);
    }, [item, onClick]);

    const onMoreIconClickCb: GetComponentProps<
      typeof ListItem
    >['onMoreIconClick'] = useCallback(
      e => {
        e.event.DOMEvent?.stopPropagation?.();

        onMoreIconClick?.(e, item);
      },
      [item, onMoreIconClick],
    );

    return (
      <Clickable onClick={onClickCb}>
        <ListItem
          onMoreIconClick={onMoreIconClickCb}
          repeat={model.repeat}
          time={model.time}
          title={model.title}
          // @ts-expect-error: TODO: describy why
          variant={model.type}
        />
      </Clickable>
    );
  },
);
